import React from "react";
import Flexbox from "flexbox-react";
import { inject, observer } from "mobx-react";
import { Icon } from "@blueprintjs/core";

import "../goal_report/GoalReportPage.css";
import TotalGoals from "../../assets/TotalGoals.svg";
import TotalEmployees from "../../assets/TotalEmployees.svg";
import EmployeeWithoutGoal from "../../assets/EmployeeWithoutGoal.svg";
import EmpNotUpdatedGoal from "../../assets/EmpNotUpdatedGoal.svg";

//import "./GoalReportPage.css";



const GoalTableInfoCard = ({ card }) => {


  const {
    title,
    data,
    icon,
    info,
    valueColor,
    iconColor,
    className = ""
  } = card;

  return (
    <Flexbox flexGrow={1}>
      <Flexbox
        flexDirection="column"
        className={`report-card-box ${className}`}
      >
        <p className="report-card-title" style={{color: "#4d4d4d"}}>
          {title}
        </p>

        <Flexbox
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          style={{ minHeight: "60px" }}
        >
          <p
            className="report-card-data"
            style={{
              color: valueColor || undefined
            }}
          >
            {data}
          </p>


          {icon && (
            <div
              className="report-card-icon"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "12px",
                background: "#EFF6FF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                color: "#2563EB"
              }}
            >
              <img
                src={icon}
                alt=""
                width={28}
                height={28}
              />
            </div>
          )}

         
        </Flexbox>

        {info && (
          <p className="report-card-info">
            {info}
          </p>
        )}
      </Flexbox>
    </Flexbox>
  );
};

export default GoalTableInfoCard;